import { Group } from '@mantine/core';

import PrivateLayoutReports from './PrivateLayout.reports';
import MenuLink from './MenuLink';
import { useAvailabilityPageAccess } from '@/hooks/useAvailabilityAccess';
import { useMenusPageAccess } from '@/hooks/useMenusPageAccess';
import { usePermissions } from '@/permissions';
import { Page, ROUTES } from '@/constants';

const PrivateLayoutMenu = () => {
  const { canAccess } = usePermissions();
  const { hasAccess: hasAvailabilityAccess } = useAvailabilityPageAccess();
  const { hasAccess: hasMenusAccess } = useMenusPageAccess();
  return (
    <>
      <Group gap="xs" wrap="nowrap" visibleFrom="sm">
        <MenuLink to={ROUTES[Page.Dashboard]} icon="IconLayoutDashboardFilled" title="Dashboard" />
        {canAccess(Page.Calendar) && (
          <MenuLink to={ROUTES[Page.Calendar]} icon="IconCalendar" title="Calendar" />
        )}
        {hasAvailabilityAccess && (
          <MenuLink to={ROUTES[Page.Availability]} icon="IconCalendarTime" title="Availability" />
        )}
        {hasMenusAccess && (
          <MenuLink to={ROUTES[Page.Menus]} icon="IconToolsKitchen2" title="Menus" />
        )}
      </Group>
      <PrivateLayoutReports />
    </>
  );
};

export default PrivateLayoutMenu;
